import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import DropDown from "../common/SearchableSelect";
import {
  getRatePerHour,
  updateJobInfoDetails,
  updateTemplateDescJobInfo,
  updateBillingRate,
  getMultishiftAmount,
  getAuthUsers,
  getIncentiveMarkup,
  masterDataBasedonJobLevel,
  setEMREHRSystemExperience,
  setMedicalSpecialities,
  setCertification,
  totalShiftAmountCalculation
} from "./action";
import { jobOpportunitySelector } from "./selector";
import { setJobShiftAmountMultishiftOccurreneUpdateList, setjobMultishiftOccurreneUpdateList } from "./slice";
import { guid } from '@progress/kendo-react-common';
import { setencounterCalculation } from './slice'
import { OverlayTrigger, Popover } from "react-bootstrap";
import "./jobOpportunity.css";
import { payRateTypeObj } from "../../helpers/data";
import { formatNumberWithCommas, formatNumberWithoutCommas, handleDecimalValueOnOnChange } from "../../helpers/regEx";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const { masterData, jobInfo, errors, location, shift, recursionFlag, JobEncounterOccurreneUpdateList, jobMultishiftOccurreneUpdateList,
    rrurle, jobShiftAmountMultishiftOccurreneUpdateList, encounterCalculation, authUsersList, incentiveMarkup ,} =
    useSelector(jobOpportunitySelector);
  const payRateType = useSelector((store) => store.jobOpportunity.payRateType);
  const payRateOccurrenceAmount = useSelector((store) => store.jobOpportunity.payRateOccurrenceAmount);
  const dispatch = useDispatch();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const updateJobInfo = (target) => {
    if (target.name === "jobTemplate") {
      dispatch(updateTemplateDescJobInfo(`${config.baseUrl}`, target.value));
    } else if (target.name === "jobCategory") {
      dispatch(
        updateJobInfoDetails(`${config.baseUrl}`, "jobTitle", target.value.name)
      );
    }
    dispatch(
      updateJobInfoDetails(`${config.baseUrl}`, target.name, target.value)
    );

  //   dispatch(setEMREHRSystemExperience({
  //     definedExperience: [],
  //     otherExperience: [
  //         {
  //             name: '',
  //             mandatory: false
  //         }
  //     ]
  // }));
  // dispatch(setMedicalSpecialities({
  //     speciality: [],
  //     otherSpeciality: [
  //         {
  //             name: '',
  //             yearsOfExperience: 0
  //         }
  //     ]
  // }));
  // dispatch(setCertification({
  //     definedCertification: [],
  //     otherCertification: [
  //         {
  //             name: '',
  //             mandatory: false
  //         }
  //     ]
  // }));
  // props?.specialitySelectRef.current.resetSelectedValues()
  // props?.certificationRef.current.resetSelectedValues()
  // props?.emrehrRef.current.resetSelectedValues()
    const params = {
      jobLevel:[target.value.id]
    }
    dispatch(masterDataBasedonJobLevel({url:config.baseUrl,params}))

    // if (target.value?.id && location?.locationNameInfo?.id) {
    //     const params = {
    //         "employerUniqueId": login.employerUniqueId,
    //         "locationId": location?.locationNameInfo?.id,
    //         "jobCategoryId": target.value?.id
    //     }
    //     config.baseUrl && dispatch(getRatePerHour({ url: config.baseUrl, params }))
    // }
  };
  useEffect(() => {
    setTimeout(() => window.enableSummerNote(), 2000);
  }, [jobInfo]);


  // useEffect(() => {
  //   if (shift?.date && shift?.startTime && shift?.endTime && recursionFlag?.toString() !== "2") {
  //     let startTime = "";
  //     let endTime = "";
  //     const start = moment(shift?.startTime?.id, "hh:mm:ss").format(
  //       "hh:mm:ss A"
  //     );
  //     const end = moment(shift?.endTime?.id, "hh:mm:ss").format("hh:mm:ss A");
  //     //console.log(end);
  //     const startAmPM = start.split(" ")[1];
  //     const endAmPM = end.split(" ")[1];
  //     //console.log(startAmPM, endAmPM);
  //     // (startAmPM === "AM" && endAmPM === "AM") 
  //     const d1 = moment(
  //       shift?.date + " " + shift?.startTime?.id,
  //       "YYYY-MM-DD hh:mm:ss"
  //     )
  //     const d2 = moment(
  //       shift?.date + " " + shift?.endTime?.id,
  //       "YYYY-MM-DD hh:mm:ss"
  //     )
  //     // console.log(moment(
  //     //   shift?.date + " " + shift?.startTime?.id,
  //     //   "YYYY-MM-DD hh:mm:ss"
  //     // ));
  //     // console.log(moment(
  //     //   shift?.date + " " + shift?.endTime?.id,
  //     //   "YYYY-MM-DD hh:mm:ss"
  //     // ));
  //     // console.log(d2.isAfter(d1));
  //     // (startAmPM === "PM" && endAmPM === "AM")
  //     if (!d2.isAfter(d1)) {
  //       // console.log('inside');
  //       startTime = moment(
  //         shift?.date + " " + shift?.startTime?.id,
  //         "YYYY-MM-DD hh:mm:ss"
  //       );
  //       endTime = moment(
  //         shift?.date + " " + shift?.endTime?.id,
  //         "YYYY-MM-DD hh:mm:ss"
  //       ).add(1, "days");
  //       //console.log(endTime);
  //     } else {
  //       // console.log('out');
  //       startTime = moment(
  //         shift?.date + " " + shift?.startTime?.id,
  //         "YYYY-MM-DD hh:mm:ss"
  //       );
  //       endTime = moment(
  //         shift?.date + " " + shift?.endTime?.id,
  //         "YYYY-MM-DD hh:mm:ss"
  //       );
  //     }
  //     // const startTime = moment(shift?.startTime?.id, "hh:mm:ss");
  //     // const endTime = moment(shift?.endTime?.id, "hh:mm:ss");
  //     const duration = moment.duration(endTime.diff(startTime));
  //     // console.log(duration);
  //     // console.log(jobInfo?.billingrate);
  //     if (
  //       duration?._data &&
  //       (duration?._data?.days || duration?._data?.hours || duration?._data?.minutes) &&
  //       jobInfo?.billingrate
  //     ) {
  //       const shiftamount =
  //         jobInfo?.billingrate *
  //         ((duration?._data?.days * 24) + (duration?._data?.hours + duration?._data?.minutes / 60));
  //       if (shiftamount) {
  //         //console.log(shiftamount);
  //         dispatch(
  //           updateJobInfoDetails(
  //             `${config.baseUrl}`,
  //             "shiftamount",
  //             shiftamount?.toFixed(2)
  //           )
  //         );
  //       }
  //     }
  //   }
  // }, [shift, jobInfo?.billingrate]);
  useEffect(() => {
    if (recursionFlag?.toString() === "1") {
      const totalval =
        (jobInfo?.incentive ? parseFloat(jobInfo?.incentive) : 0) +
        parseFloat(jobInfo?.shiftamount);
      dispatch(
        updateJobInfoDetails(
          `${config.baseUrl}`,
          "total",
          Number(totalval)?.toFixed(2)
        )
      );
    }
  }, [recursionFlag, jobInfo?.incentive])
  useEffect(() => {
    if (jobInfo?.shiftamount) {
      const totalval =
        (jobInfo?.incentive ? parseFloat(jobInfo?.incentive) : 0) +
        parseFloat(jobInfo?.shiftamount);
      dispatch(
        updateJobInfoDetails(
          `${config.baseUrl}`,
          "total",
          Number(totalval)?.toFixed(2)
        )
      );

    }
    if (jobInfo?.incentive) {
      if (recursionFlag?.toString() === "3") {
        const incentiveVal = ""
        dispatch(
          updateJobInfoDetails(
            `${config.baseUrl}`,
            "incentive",
            incentiveVal
          )
        )
      }
    }
  }, [jobInfo?.incentive, jobInfo?.shiftamount, recursionFlag?.toString() === "3"]);

  useEffect(() => {
    if (recursionFlag?.toString() === "2") {
      const totalval = (jobInfo?.incentive ? parseFloat(jobInfo?.incentive) : 0) +
        parseFloat(jobInfo?.billingrate);
      dispatch(
        updateJobInfoDetails(
          `${config.baseUrl}`,
          "total",
          Number(totalval)?.toFixed(2)
        )
      );
    }

  }, [jobInfo?.billingrate, jobInfo?.incentive, recursionFlag?.toString() === "2"]);

  const updateValue = (target) => {
    // var validNumber = new RegExp(/^\d*\.?\d*$/);
    const {value} = target;
    const removeExistComma = formatNumberWithoutCommas(value);
    const decimalConversion = handleDecimalValueOnOnChange(removeExistComma);
    if (decimalConversion.length <= 7) {
      dispatch(
        updateJobInfoDetails(`${config.baseUrl}`, "incentive", decimalConversion)
      );
    }
  };

  // useEffect(() => {
  //   // if (jobInfo?.jobCategory && jobInfo?.jobCategory?.id && parseInt(recursionFlag) !== 2) {
  //   if (jobInfo?.jobCategory && jobInfo?.jobCategory?.id && parseInt(recursionFlag) !== 2 && shift?.startTime?.id && shift?.endTime?.id && shift.date && location?.locationNameInfo?.id) {
  //     const params = {
  //       employerUniqueId: login.employerUniqueId,
  //       locationId: location?.locationNameInfo?.id,
  //       jobCategoryId: jobInfo?.jobCategory?.id,
  //       startTime: shift?.startTime?.id,
  //       endTime: shift?.endTime?.id,
  //       recursionFlag: recursionFlag,
  //       shiftDate: shift.date
  //     };
  //     config.baseUrl &&
  //       dispatch(getRatePerHour({ url: config.baseUrl, params }));
  //   }
  // }, [jobInfo?.jobCategory, shift.date, shift?.startTime?.id, shift?.endTime?.id, recursionFlag, location?.locationNameInfo?.id, rrurle]);

  useEffect(() => {
    const amount = {};
    const details = []
    JobEncounterOccurreneUpdateList.forEach((item) => {
      if (amount.hasOwnProperty(item.candidateUniqueId)) {
        amount[item.candidateUniqueId]?.push(item);
      } else {
        amount[item.candidateUniqueId] = [item];
      }
    });

    for (let key in amount) {
      let value = [];
      if (amount[key]) {
        amount[key].map(item => {
          const index = value.findIndex(el => el.shiftDate === moment(item.Start).format("MM/DD/YYYY"));
          if (index < 0) {
            value.push({ id: key, shiftDate: moment(item.Start).format("MM/DD/YYYY"), date: moment(item.Start).format('YYYY-MM-DDTHH:mm:ss'), shiftamount: item.billingRate, incentive: item?.incentive ? item?.incentive : '', total: Number((item.incentive ? parseFloat(item.incentive) : 0) + parseFloat(item.billingRate)).toFixed(2) });
          } else {
            value[index].shiftamount += item.billingRate ? item.billingRate : 0;
            value[index].total = Number((value[index].incentive ? parseFloat(value[index].incentive) : 0) + parseFloat(value[index].shiftamount)).toFixed(2)
          }

        })
      }
      details.push(...value)
    }
    if (details?.length > 0) {
      if (encounterCalculation?.length === 0) {
        const candidateUniqueId = [...new Set(details.map(item => item.id))]
        dispatch(setencounterCalculation(candidateUniqueId.map(item => { return { candidateUniqueId: item, shiftinfo: details.filter(val => val.id === item) } })));
      } else {
        const candidateUniqueId = [...new Set(details.map(item => item.id))]
        const newVal = JSON.parse(JSON.stringify(encounterCalculation));
        newVal.forEach(item => {
          item.shiftinfo.forEach(item2 => {
            const index = details.findIndex(val => item.candidateUniqueId === val.id && item2.shiftDate === val.shiftDate);
            const filter = details.filter(val => item.candidateUniqueId === val.id && item2.shiftDate === val.shiftDate)
              .map(val2 => { return { ...val2, incentive: item2.incentive, total: Number((item2.incentive ? parseFloat(item2.incentive) : 0) + parseFloat(val2.shiftamount)).toFixed(2) } });
            if (index !== -1) {
              details.splice(index, 1, ...filter);
            }
          })
        })
        dispatch(setencounterCalculation(candidateUniqueId.map(item => { return { candidateUniqueId: item, shiftinfo: details.filter(val => val.id === item) } })));
      }
    }
  }, [JobEncounterOccurreneUpdateList])


  useEffect(() => {
    if (
      !jobMultishiftOccurreneUpdateList.length &&
      rrurle &&
      recursionFlag?.toString() === '3' && shift.startTime?.name && shift.endTime?.name && shift.date && jobInfo?.billingrate
    ) {
      const startDateFormat = moment(
        shift.date + ' ' + shift.startTime.name,
        'YYYY-MM-DD H:mm A'
      );
      const endDateFormat = moment(
        shift.date + ' ' + shift.endTime.name,
        'YYYY-MM-DD H:mm A'
      );

      const calenderRequestBody = {
        TaskID: guid(),
        ownerID: guid(),
        Title: 'Shift Info',
        Description: '',
        StartTimezone: null,
        Start: new Date(startDateFormat),
        End: new Date(endDateFormat),
        EndTimezone: null,
        RecurrenceRule: rrurle,
        RecurrenceID: null,
        RecurrenceException: [],
        isAllDay: false,
        locationId: location.locationNameInfo?.id,
        jobsContactsList: location.contactPersons.map(item => item.id),
        jobsApproversList: location.approvalUsers.map(item => item.id),
        billingrate: jobInfo?.billingrate ? jobInfo?.billingrate : '',
        shiftLength: shift.preferedShift?.id ? shift.preferedShift?.id : '',
        editDay: false,
        payRateOccurrenceAmount: (+payRateType === payRateTypeObj.manualCal) ? payRateOccurrenceAmount : null
      };
      dispatch(
        setjobMultishiftOccurreneUpdateList(
          JSON.parse(JSON.stringify([calenderRequestBody]))
        )
      );
    }
  }, [jobInfo?.billingrate, recursionFlag?.toString() === '3', rrurle, shift.startTime?.name, shift.endTime?.name, shift?.date, shift?.endDate, location.locationNameInfo?.id, location.contactPersons, location.approvalUsers,payRateOccurrenceAmount])
  // const shiftAMountCondition =(parseInt(jobInfo?.billingrate)) && (parseInt(jobInfo?.ratePerHour))

  // useEffect(() => {
  //   if ((parseInt(jobInfo?.billingRateParam)) && (jobShiftAmountMultishiftOccurreneUpdateList.length || jobMultishiftOccurreneUpdateList.length) && recursionFlag?.toString() === '3' && shift?.date && shift?.endDate && jobInfo?.jobCategory?.id) {
  //     // console.log({ data: jobShiftAmountMultishiftOccurreneUpdateList });
  //     const params = {
  //       ratePerHour: jobInfo?.ratePerHour,
  //       hourlyBillingRate: jobInfo?.billingRateParam,
  //       jobDate: shift?.date,
  //       jobEndDate: shift?.endDate,
  //       jobCategoryId: jobInfo?.jobCategory?.id
  //     };
  //     config.baseUrl &&
  //       dispatch(getMultishiftAmount({ url: config.baseUrl, params, shiftAmountMultishiftOccurrence: jobMultishiftOccurreneUpdateList.length ? jobMultishiftOccurreneUpdateList : jobShiftAmountMultishiftOccurreneUpdateList }));
  //   }

  // }, [jobInfo?.billingRateParam, jobMultishiftOccurreneUpdateList, jobInfo?.jobCategory?.id])
  useEffect(() => {
    if(jobMultishiftOccurreneUpdateList?.length === 0) {
      dispatch(totalShiftAmountCalculation())
    }
  },[jobMultishiftOccurreneUpdateList?.length])
  const encounterIncentive = (target, candidateUniqueId, shiftDate) => {
    const {value} = target;
    const removeExistComma = formatNumberWithoutCommas(value);
    const decimalConversion = handleDecimalValueOnOnChange(removeExistComma);
    // var validNumber = new RegExp(/^\d*\.?\d*$/);
    if (decimalConversion?.length <= 7) {
      const newVal = JSON.parse(JSON.stringify(encounterCalculation));
      newVal.map((item) => {
        if (item.candidateUniqueId === candidateUniqueId) {
          item.shiftinfo.map(item2 => {
            if (item2.shiftDate === shiftDate) {
              item2.incentive = decimalConversion;
              item2.total = Number((decimalConversion ? parseFloat(decimalConversion) : 0) + parseFloat(item2.shiftamount)).toFixed(2)
            }
          })
        }
      })
      dispatch(setencounterCalculation(newVal))
    }
  }

  const getAuthUserName = (id) => {
    const user = authUsersList.filter(item => item.value.toLowerCase() === id.toLowerCase());
    if (user?.length > 0) {
      return user[0]?.label
    } else {
      return ''
    }
  }


  useEffect(() => {
    if (jobMultishiftOccurreneUpdateList?.length > 1) {
      const groupArray = [...new Set(jobMultishiftOccurreneUpdateList?.map(item => item?.locationId))]
      // console.log({groupArray});
      if (groupArray?.length > 1) {
        dispatch(updateJobInfoDetails(`${config.baseUrl}`, "billingrate", "Variable"))
      } else {
        const mainResult = jobMultishiftOccurreneUpdateList?.every(item => moment(item?.Start).format("hh:mm A") === shift?.startTime?.name && moment(item?.End).format("hh:mm A") === shift?.endTime?.name)
        const billingRateList = jobMultishiftOccurreneUpdateList?.map(item => item?.billingrate);
        if (groupArray?.length === 1 && (mainResult || billingRateList?.indexOf('Variable') === -1)) {
          dispatch(updateJobInfoDetails(`${config.baseUrl}`, "billingrate", jobInfo?.restoreBillingrate))
        }
      }
    }
  }, [jobMultishiftOccurreneUpdateList, jobInfo?.billingRateParam])
  
  // get Incentive Markup
  useEffect(() => {
    if (config.baseUrl ) {
      let shiftDayFormat = ""
      if(parseInt(recursionFlag) !== 2 && shift?.date && shift?.startTime?.id){
        const shiftDay= moment(shift?.date + "" + shift?.startTime?.id, "YYYY-MM-DD hh:mm:ss");
        shiftDayFormat = `${moment(shiftDay).format('YYYY-MM-DDTHH:mm:ss')}Z`
      } else if (parseInt(recursionFlag) === 2 && JobEncounterOccurreneUpdateList?.length){
        const copyEncounterOccurrenceList = [...JobEncounterOccurreneUpdateList];
        const sortBasedonDate = copyEncounterOccurrenceList?.sort((a,b) => new Date(a?.Start) - new Date(b?.Start))
        shiftDayFormat = sortBasedonDate?.length && `${moment(sortBasedonDate?.[0]?.Start).format("YYYY-MM-DDTHH:mm:ss")}Z`
      }
      if(shiftDayFormat && location?.locationNameInfo?.id && jobInfo?.jobCategory?.id){
        const IncentiveMarkupParams = {
          locationId: location?.locationNameInfo?.id,
          jobCategoryId: jobInfo?.jobCategory?.id,
          shiftDate:shiftDayFormat
        }
        dispatch(getIncentiveMarkup(`${config.baseUrl}`, IncentiveMarkupParams, parseInt(recursionFlag)));
      }
    }
  }, [config, location?.locationNameInfo?.id, jobInfo?.jobCategory?.id, recursionFlag,shift?.date,shift?.startTime?.id,JobEncounterOccurreneUpdateList?.length])

  // Millegae Popover showing the Table
  const mileage = (
    <Popover id="popover-basic">
      <Popover.Body>
        <table className="table table-responsive">
          <thead>
            <tr>
              <th className="text-capitalize">Start Mile</th>
              <th className="text-capitalize">End Mile</th>
              <th className="text-capitalize">Mileage Multiplier</th>
            </tr>
          </thead>
          <tbody>
            {
              jobInfo?.mileage?.map((item, index) => {
                return (
                  <tr className="border-bottom mt-2 bg-white">
                    <td>{item?.startMile}</td>
                    <td>{item?.endMile}</td>
                    <td>{item?.mileageMultiplier} %</td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </Popover.Body>
    </Popover>
  )

  // PayRate Popover Showing Table
  const payRates = (
    <Popover id="popover-basic">
      <Popover.Body>
        <table className="table table-responsive">
          <thead>
            <tr>
              <th className="text-capitalize">Start Time</th>
              <th className="text-capitalize">End Time</th>
              <th className="text-capitalize">Candidate Rate</th>
              <th className="text-capitalize">Billing Rate</th>
            </tr>
          </thead>
          <tbody>
            {
              jobInfo?.payRates?.map((item, index) => {
                return (
                  <tr className="border-bottom mt-2 bg-white">
                    <td>{moment(item?.shiftStartTime, "hh:mm").format("hh:mm A")}</td>
                    <td>{moment(item?.shiftEndTIme, "hh:mm").format("hh:mm A")}</td>
                    <td>{item?.hourlyPayRate}</td>
                    <td>{item?.totalRate}</td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </Popover.Body>
    </Popover>
  )


  return (
    <div className="card">
      <div>
        <div className="row">
          <div className="card-header">
            <h3 class="card-title">Shift Level</h3>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="form-group">
                {parseInt(recursionFlag) === 1 ?
                  <div className="col-10">
                    <div className="d-flex align-items-center justify-content-between">
                      <DropDown
                        name={"jobCategory"}
                        id={"jobCategory"}
                        label="Shift Position Title"
                        star="*"
                        options={masterData?.allJobCategory}
                        value={jobInfo.jobCategory ? [jobInfo?.jobCategory] : []}
                        multiple={false}
                        updateValue={updateJobInfo}
                        isObject={true}
                        errors={props.errors ? props.errors["jobCategory"] : []}
                        divClass={"col-lg-4 col-md-4"}
                      />
                      <div className="text-center">
                        <label htmlFor={"Incentive"}>Incentive</label>
                       <div style={{position:"relative"}} className="d-flex align-items-center default-checkbox">
                        {
                          jobInfo?.incentive ? <span style={{position:"absolute" , left:"10px"}}>$</span>:''
                        }
                       <input
                          type="text"
                          className="form-control disbleclass"
                          placeholder="Enter Incentive Amount"
                          disabled={recursionFlag?.toString() === "3"}
                          value={jobInfo?.incentive ? formatNumberWithCommas(jobInfo?.incentive) : ""}
                          onChange={(event) => updateValue(event.target)}
                        />
                       </div>
                      </div>
                      <div className="text-center">
                        <label htmlFor={"Incentive Amount"}>Incentive Billing Amount</label>
                        <div className="form-control border-0">
                          {`$ `}{formatNumberWithCommas(Math.round((parseFloat(jobInfo?.incentive * incentiveMarkup)) * 100) / 100) ?? ""}
                        </div>
                      </div>
                    </div>
                  </div> : ""}
                {parseInt(recursionFlag) !== 2 ?
                  <div>
                    <div className="d-md-flex align-items-center justify-content-start gap-3">
                      {/* <div>
                        <label htmlFor={"billingrate"}>Billing Rate</label>
                        <div className="form-control" style={{ border: "0px" }}>
                          {jobInfo?.billingrate ? `${jobInfo?.billingrate === "Variable" ? "" : '$'}${jobInfo?.billingrate}` : "$0"}
                        </div>
                        <div className="form-control" style={{ border: "0px" }}>
                      {jobInfo?.billingrate ? `$${jobInfo?.billingrate}` : "$0"}
                    </div>
                      </div> */}

                      {/* <div >
                      <label>Mileage</label>
                      <div className="form-control border-0">
                        <OverlayTrigger
                          placement="right"
                          delay={{ show: 250, hide: 400 }}
                          overlay={mileage}
                        >
                          <i class="fa fa-question-circle " style={{ fontSize: "15px", marginTop: "4px", cursor: "pointer" }} aria-hidden="true"></i>
                        </OverlayTrigger>
                      </div>
                    </div> */}

                      {/* <div>
                        <label htmlFor={"shiftamount"}>Shift Amount</label>
                        <div className="form-control border-0">
                          {jobInfo?.shiftamount ? `$${jobInfo?.shiftamount}` : "$0"}
                        </div>
                      </div> */}
                      {/* <div>
                        <label>PayRates</label>
                        <div className="form-control border-0">
                          <OverlayTrigger
                            placement="right"
                            delay={{ show: 250, hide: 400 }}
                            overlay={payRates}
                          >
                            <i class="fa fa-question-circle" style={{ fontSize: "15px", marginTop: "4px", cursor: "pointer" }} aria-hidden="true"></i>
                          </OverlayTrigger>
                        </div>
                      </div> */}
                      {/* <div className="text-center">
                        <label htmlFor={"Incentive"}>Incentive</label>
                        <input
                          type="text"
                          className="form-control disbleclass"
                          placeholder="Enter Incentive Amount"
                          disabled={recursionFlag?.toString() === "3"}
                          value={jobInfo?.incentive}
                          onChange={(event) => updateValue(event.target)}
                        />
                      </div>
                      <div className="text-center">
                        <label htmlFor={"Incentive Amount"}>Incentive Amount</label>
                        <div className="form-control border-0">
                          {Math.round((parseFloat(jobInfo?.incentive * incentiveMarkup)) * 100) / 100}
                        </div>
                      </div> */}
                      {/* <div className="text-center">
                        <label htmlFor={"total"}>
                          Total Billing Amount
                        </label>
                        <div className="form-control" style={{ border: "0px" }}>
                          ${jobInfo?.total ? (!jobInfo?.incentive ? jobInfo?.shiftamount ? jobInfo?.shiftamount : 0 : `${(parseFloat(Number(jobInfo?.shiftamount)) + parseFloat(Math.round((parseFloat(jobInfo?.incentive * incentiveMarkup) + Number.EPSILON) * 100) / 100)).toFixed(2)}`) : " 0"}
                        </div>
                      </div> */}
                    </div>
                    <div>
                      {errors && errors["billingrate"] && (
                        <div className="invalid-input">
                          {errors["billingrate"]}
                        </div>
                      )}
                    </div>
                  </div>
                  :

                  // <div className="row">
                  //   <div className="col-lg-4 col-md-4">
                  //     <label htmlFor={"billingrate"}>Encounter Rate</label>
                  //     <div className="form-control" style={{ border: "0px" }}>
                  //       {jobInfo?.billingrate ? `$${jobInfo?.billingrate}` : "$0"}
                  //     </div>
                  //     {errors && errors["billingrate"] && (
                  //       <div className="invalid-input">
                  //         {errors["billingrate"]}
                  //       </div>
                  //     )}
                  //   </div>
                  //   <div className="col-lg-4 col-md-4">
                  //     <div className="form-group">
                  //       <label htmlFor={"Incentive"}>Incentive</label>
                  //       <input
                  //         type="text"
                  //         className="form-control disbleclass"
                  //         placeholder="Enter Incentive Amount"
                  //         disabled={recursionFlag?.toString() === "3"}
                  //         value={jobInfo?.incentive}
                  //         onChange={(event) => updateValue(event.target)}
                  //       />
                  //     </div>
                  //   </div>
                  //   <div className="col-lg-4 col-md-4">
                  //     <label htmlFor={"total"}>
                  //       Total Encounter Amount
                  //     </label>
                  //     <div className="form-control" style={{ border: "0px" }}>
                  //       {jobInfo?.total ? `$${jobInfo?.total}` : "$0"}
                  //     </div>
                  //   </div>
                  // </div>
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="d-flex ">
                        <p className="col-2 fw-bold  d-flex align-items-center justify-content-center">Candidate Name</p>
                        <p className="col-10 d-flex align-items-center justify-content-between">
                          <span className="col-2  fw-bold d-flex align-items-center justify-content-center">Date</span>
                          <span className="col-2 fw-bold d-flex align-items-center justify-content-center">Encounter Rate</span>
                          <span className="col-2  fw-bold d-flex align-items-center justify-content-center">Incentive</span>
                          <span className="col-2  fw-bold d-flex align-items-center justify-content-center">Incentive Billing Amount</span>
                          <span className="col-2 fw-bold d-flex align-items-center justify-content-center">Total Billing Amount</span>
                        </p>

                      </div>
                    </div>
                    <div className="row">
                      {
                        encounterCalculation.map((item, index) => {
                          return <div className=" d-flex border-bottom">
                            <span className="col-2 h-full d-flex align-items-center justify-content-center"> {getAuthUserName(item?.candidateUniqueId)}</span>
                            <div className="col-10">
                              {
                                item.shiftinfo.map(sub => {

                                  return <>
                                    <p className="d-flex align-items-center justify-content-between m-0 py-2">
                                      <span className="col-2 d-flex align-items-center justify-content-center  h-full">{sub.shiftDate}</span>
                                      <span className="col-2 d-flex align-items-center justify-content-center h-full">{`$ `}{formatNumberWithCommas(parseFloat(sub.shiftamount).toFixed(2))}</span>
                                      <span className="col-2 d-flex align-items-center justify-content-center h-full">
                                      <div style={{position:"relative"}} className="d-flex align-items-center default-checkbox">
                                        {
                                          sub.incentive ? <span style={{position:"absolute" , left:"10px"}}>$</span>:''
                                        }
                                       <input
                                          type="text"
                                          className="form-control disbleclass"
                                          placeholder="Enter Incentive Amount"
                                          disabled={recursionFlag?.toString() === "3"}
                                          value={sub?.incentive ? formatNumberWithCommas(sub?.incentive):sub?.incentive}
                                          onChange={(event) => encounterIncentive(event.target, item?.candidateUniqueId, sub.shiftDate)}
                                        />
                                      </div>
                                     
                                      </span>
                                      <span className="col-2 d-flex align-items-center justify-content-center h-full">{`$ `} {formatNumberWithCommas(Math.round((parseFloat(sub.incentive * incentiveMarkup) + Number.EPSILON) * 100) / 100) ?? ""}</span>
                                      <span className="col-2 d-flex align-items-center justify-content-center h-full"> {`$ `}{formatNumberWithCommas((sub.shiftamount + (sub.incentive * incentiveMarkup)).toFixed(2)) ?? ""}</span>
                                    </p>
                                  </>
                                })
                              }
                            </div>
                          </div>
                        })
                      }
                    </div>
                  </div>
                }

              </div>
              <div className="form-group">
                <label htmlFor={"summernote"}>Shift Description</label>
                <div
                  id="summernote"
                  dangerouslySetInnerHTML={{ __html: jobInfo?.jobDescription }}
                ></div>
                {errors && errors["jobDescription"] && (
                  <div className="invalid-input">
                    {errors["jobDescription"]}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};
